// ─── Profil : choix PAR CALENDRIER IVV (Core) ─────────────────────
// Sous-liste affichée sous la bascule « Voir les calendriers IVV » : une
// bascule par calendrier IVV accessible. La sélection (users/{uid}.
// prefIvvMasques = ids masqués) est CONSERVÉE quand on coupe la bascule
// générale — on retrouve son choix à la réactivation.
import React, { useEffect, useMemo, useState } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { collection, onSnapshot, query, where, doc, setDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { useUI } from '../theme/PreferencesUI';
import Bascule from '../ui/Bascule';

const estCalIvv = (id) => id === 'ivv' || String(id || '').startsWith('ivv-cal-');

export default function ListeCalIvv({ user }) {
  const UI = useUI();
  const s = useMemo(() => makeStyles(UI), [UI]);
  const [cals, setCals] = useState([]);

  useEffect(() => {
    if (!user?.uid) return undefined;
    const q = query(collection(db, 'calendriers'), where('accesUids', 'array-contains', user.uid));
    return onSnapshot(q, (snap) => {
      setCals(snap.docs.map(d => ({ id: d.id, ...d.data() }))
        .filter(c => estCalIvv(c.id))
        .sort((a, b) => (a.nom || '').localeCompare(b.nom || '')));
    }, () => setCals([]));
  }, [user?.uid]);

  if (!cals.length) return null;
  const masques = user?.prefIvvMasques || [];
  const basculer = (id, visible) => {
    const set = new Set(masques);
    if (visible) set.delete(id); else set.add(id);
    setDoc(doc(db, 'users', user.uid), { prefIvvMasques: Array.from(set) }, { merge: true }).catch(() => {});
  };

  return (
    <View style={s.bloc}>
      {cals.map(c => (
        <View key={c.id} style={s.ligne}>
          <Text style={s.emoji}>{c.emoji || '📅'}</Text>
          <Text style={s.nom} numberOfLines={1}>{c.nom || c.id}</Text>
          <Bascule valeur={!masques.includes(c.id)} onChange={(v) => basculer(c.id, v)}
            accessibilityLabel={c.nom || c.id} />
        </View>
      ))}
    </View>
  );
}

const makeStyles = (UI) => StyleSheet.create({
  bloc: { marginLeft: 34, marginTop: 2, marginBottom: 8, borderLeftWidth: 2, borderLeftColor: UI.border, paddingLeft: 10, gap: 8 },
  ligne: { flexDirection: 'row', alignItems: 'center', gap: 8 },
  emoji: { fontSize: 15 },
  nom: { flex: 1, fontSize: 13, color: UI.ink, fontWeight: '600' },
});
